import { render } from "./IconButton.vue?vue&type=template&id=acb50eb4&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=acb50eb4&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-acb50eb4"

export default script